"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var utils_1 = require("../../utils");
var SharesSubmodule = /** @class */ (function () {
    function SharesSubmodule(model) {
        this.model = model;
    }
    SharesSubmodule.prototype.getShare = function (id, code) {
        return axios_1.default
            .get(this.model.baseUrl + "/shares/" + id + "?code=" + code)
            .then(function (response) { return response.data; })
            .catch(function (err) {
            throw new Error((0, utils_1.extractAxiosErrorMessage)(err));
        });
    };
    SharesSubmodule.prototype.createShare = function (body) {
        return axios_1.default
            .post(this.model.baseUrl + "/shares", body, {
            headers: {
                Authorization: "Bearer " + this.model.accessToken,
            },
        })
            .then(function (response) { return response.data; })
            .catch(function (err) {
            throw new Error((0, utils_1.extractAxiosErrorMessage)(err));
        });
    };
    return SharesSubmodule;
}());
exports.default = SharesSubmodule;
